import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { GenderDataObject } from 'models/service';

export const getGenders = async () =>
  apiClient.get<GenderDataObject[], ApiClientResponse<GenderDataObject[]>>(routes.user.genders);
